import classNames from 'classnames'
import { useMemo } from 'react'
import { AuthenticationStatus } from '@enums'
import { MainContainer } from '@components'
import { getAuthenticationStatusString } from '@utils/authentication-helpers'

// ASSETS
import CircleCheckIcon from '@assets/icons/circle-check.svg?react'
import CircleCloseIcon from '@assets/icons/circle-close.svg?react'
import HourglassIcon from '@assets/icons/hourglass-clock.svg?react'
// STYLES
import styles from './styles'

type Props = {
  authStatus?: AuthenticationStatus
  message: string
  showBrand?: boolean
}

export const Result: React.FC<Props> = ({ authStatus, message, showBrand }) => {
  const statusKey = getAuthenticationStatusString(authStatus).toLowerCase()

  const statusIcon = useMemo(() => {
    switch (authStatus) {
      case AuthenticationStatus.SUCCESS:
        return <CircleCheckIcon className="icon" />
      case AuthenticationStatus.PENDING:
        return <HourglassIcon className="icon clock" />
      case AuthenticationStatus.FAILED:
      case AuthenticationStatus.ERROR:
      case AuthenticationStatus.EXPIRED:
        return <CircleCloseIcon className="icon" />
      default:
        return null
    }
  }, [authStatus])

  return (
    <MainContainer showBrand={showBrand}>
      <div className={styles}>
        <div className={classNames('status-container', statusKey)}>
          {statusIcon}
        </div>
        <p className="message">{message}</p>
      </div>
    </MainContainer>
  )
}

export default Result
